import React from 'react'
import t from 'prop-types'
import CardInfo from '../CardInfo'
import SectionHeader from '../../Headers/SectionHeader/SectionHeader'
import FourUp from '../../Layouts/FourUp'
import TwoUp from '../../Layouts/TwoUp'

const CardInfoGroup = ({
  cards,
  hasBg,
  isOnDarkBg,
  sectionHeader,
  isTwoUp,
}) => {
  const CardWrapper = isTwoUp ? TwoUp : FourUp
  return (
    <div className="container">
      <div className="mb-20">
        <SectionHeader
          isOnDarkBg={isOnDarkBg}
          {...sectionHeader}
        ></SectionHeader>
      </div>
      <CardWrapper>
        {cards.map((card, index) => (
          <CardInfo
            key={index}
            hasBg={hasBg}
            isOnDarkBg={isOnDarkBg}
            {...card}
          />
        ))}
      </CardWrapper>
    </div>
  )
}
CardInfoGroup.propTypes = {
  cards: t.object,
  hasBg: t.bool,
  isOnDarkBg: t.bool,
  sectionHeader: t.object,
  isTwoUp: t.bool,
}

CardInfoGroup.defaultProps = {
  hasBg: false,
  isOnDarkBg: false,
  isTwoUp: false,
}

export default CardInfoGroup
